import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'

export const Divider = styled(Flex)(
  ({ whiteBorder }) => css`
    border: ${whiteBorder && `${whiteBorder}px solid white`};
  `,
)
